export default {
    'sv-SE': {
        administrator: 'administratör',
        'device-install': 'installera',
        'device-repair': 'reparera',
        add_entities: 'fordon',
        add_existing: 'lägg till från existerande',
        add_item: 'lägg till',
        add_new_location: 'spara plats',
        add_new_vehicle: 'lägg till nytt fordon',
        add_new: 'lägg till ny',
        add_order: 'arbetsuppgifter',
        add_special_note: 'anmärkning',
        add_what: 'arbetsuppgifter',
        add_where: 'hitta plats',
        add_who: 'entreprenörer',
        add: 'lägg till',
        address: 'adress',
        all: 'alla',
        approved: 'godkända',
        singular_approved: 'godkänd',
        are_you_sure: 'är du säker?',
        assigned: 'pågående',
        singular_assigned: 'pågående',
        assignee_org: 'entreprenör som har antagit ärendet',
        associated_orgs: 'associerade entreprenörer',
        associated_users: 'associerade användare',
        back: 'tillbaka',
        bus: 'buss',
        buses: 'bussar',
        cancel: 'avbryt',
        change_state: 'ändra status',
        change_state_completed: 'utförd',
        change_state_not_completed: 'ej utförd',
        completed: 'färdiga',
        contractor: 'entreprenör',
        singular_completed: 'färdig',
        concurrent_modification: 'kollision',
        concurrent_modification_desc:
            'Någon annan har manipulerat det objekt du just ville ändra på. Därför har vi avbrutit din ändring tills du har haft en chans att se över objektet och besluta dig för om du fortfarande vill göra din ändring.',
        confirm_leave_view: 'är du säker på att du vill avbryta?',
        confirm: 'bekräfta',
        create_add_task: 'lägg till arbetsuppgift',
        create_edit_location_subtitle: 'platå, servicehall eller adress',
        create_entities_bread:
            'Till höger lägger du till de fordon som ärendet gäller för.',
        create_entities_subtitle: 'Lägg till fordon till höger',
        create_entities_title: 'På vilka fordon ska arbetet utföras?',
        create_manually: 'skapa manuellt',
        create_summary_bread: 'kontrollera att alla uppgifter stämmer',
        create_summary_title: 'Summering av ärende',
        create_what_bread:
            'Lägg till vad som ska göras på fordonen till höger. Ett ärende kan innehålla fritt antal arbetsuppgifter.',
        create_what_subtitle: 'Lägg till Arbetsuppgifter',
        create_what_title: 'Vilka arbetsuppgifter ska utföras?',
        create_where_bread: 'Hitta din plats till höger',
        create_where_subtitle: 'var',
        create_where_title: 'På vilken plats befinner sig fordonen?',
        create_who_bread:
            'Välj en eller flera entreprenörer som kan utföra arbetet. Den entreprenör som antar ärendet utför det.',
        create_who_subtitle: 'vem',
        create_who_title: 'Vem ska göra det?',
        created_by: 'skapad av',
        created_date: 'skapad',
        creator: 'skapad av',
        invoice_info: 'faktureringsuppgifter',
        date: 'datum',
        do_you_want_to_delete_this_picture:
            'Vill du verkligen ta bort denna bild?',
        delete: 'ta bort',
        depot: 'depå',
        describe_task: 'fyll i information om arbetsuppgiften',
        describe_why_admin_order_complete:
            'alla uppgifter som inte svarats av kommer att automatiskt svaras av som ej utförda. Beskriv nedan varför ni valt att tvinga en färdigställning av detta uppdrag.',
        describe_why_admin_order_reject:
            'ärendet kommer att skickas tillbaka till entreprenören. Beskriv nedan varför ni valt att skicka tillbaka ärendet.',
        edit: 'redigera',
        editing: 'redigerar',
        empty_list: 'tomt',
        enter_address: 'ange adress',
        enter_location: 'ange plats',
        enter_message: 'skriv meddelande',
        enter_new_tag: 'lägg till ny tagg',
        enter_note_for: 'anmärkning för',
        enter: 'ange',
        entities: 'fordon',
        entity: 'fordon',
        entrepreneur: 'entreprenör',
        error_has_occured: 'något har gått fel',
        fetching_data: 'laddar data',
        file_is_of_wrong_type: 'filen är av fel typ',
        have_you_edited_the_vehicle:
            'har du lagt till, tagit bort eller åtgärdat en inventarie i fordonet?',
        history: 'historik',
        id_reg: 'ID / Reg',
        id: 'id',
        id_needs_to_be_selected: 'ID fält måste väljas.',
        incomplete_create_order_wizard:
            'Lägg till minst en entreprenör, uppgift och fordon.',
        information: 'information',
        inventory: 'inventarier',
        jlt: 'JLT',
        jlt_vehicle_number: 'JLT Fordonsnummer',
        last_edit: 'senast modifierad',
        list: 'lista',
        map: 'karta',
        messages: 'meddelanden',
        mine: 'mina',
        misc: 'fritext',
        new_tag: 'skapa ny tagg',
        next: 'nästa',
        none_added_to_list: 'inga tillagda',
        no_location: 'ingen plats angiven',
        no_orders_in_completed_state:
            'inga ärenden väntar på administratörens godkännande',
        no_orders: 'inga ärenden',
        no_orders_in_state: 'det finns inga ärenden som har status',
        no_org: 'ingen entreprenör',
        no_published_orders: 'inga oavklarade ärenden finns utlagda',
        no_result_entities: 'Hittade inget fordon',
        no_result_what: 'Det finns inga mallar för arbetsuppgifter',
        no_result_who: 'Hittade ingen entreprenör',
        no_search_results: 'inga resultat för söktermer',
        no_vehicles: 'inga fordon',
        no_vehicles_added: 'det finns inga fordon tillagda',
        no: 'nej',
        not_implemented: 'inte implementerat',
        not_implemented_in_test_version: 'inte implementerat i test versionen',
        order: 'ärende',
        orders: 'ärenden',
        order_removal_long:
            'notera att ärendet och dess uppgifter försvinner ur all statistik.',
        order_state_change_complete: 'färdigställ',
        order_state_change_reject: 'tillbakavisa',
        order_state_change_approve: 'godkänn',
        photos: 'foton',
        place_new_order: 'lägg ut nytt ärende',
        place_order: 'lägg ut ärende',
        previous: 'tillbaka',
        priority: 'prioritet',
        published: 'utlagda',
        singular_published: 'utlagd',
        remove: 'ta bort',
        save: 'spara',
        search: 'sök',
        send: 'skicka',
        separate_search:
            'Sök multipla fält genom att separera dina sökord med mellanslag',
        start: 'start',
        state: 'status',
        summary: 'summering',
        some_not_matching_schema: 'Dessa rader importeras inte.',
        task_description: 'beskrivning',
        task_save: 'lägg till arbetsuppgift',
        task_tags: 'tagga arbetsuppgiften',
        task_type: 'typ av arbetsuppgift',
        tasks: 'arbetsuppgifter',
        trains: 'tåg',
        unauthorized_not_admin_long:
            'ditt användarkonto saknar administratörsrättigheter och kan därför inte användas för att logga in här',
        unknown: 'okänt',
        upload: 'ladda upp',
        vehicle_type: 'fordonstyp',
        vehicles: 'fordon',
        vehicle: 'fordon',
        vin_number: 'chassi nummer',
        what: 'arbetsuppgifter',
        where: 'plats',
        who: 'entreprenör',
        yes: 'ja',
        you_have_no_associated_orders:
            'du har inga ärenden associerade med dig',
        exclude: 'exkludera',
        import_excel: 'Importera excel',
        something_wrong_with_your_excel:
            'Du ar valt ett icke kompatibelt excel ark',
        select_sheet: 'välj blad',
    },
    'en-US': {},
};



// WEBPACK FOOTER //
// ./src/translations.js